<template>
  <v-overlay :value="value"
    class="carousel"
    opacity="0.9">
    <div class="carousel-wrapper">
      <v-row class="actions"
        align="center" justify="end">
        <v-col cols="auto">
          <c-btn outlined color="white"
            css="mx-5"
            @click="close">
            <v-icon>close</v-icon>
            {{ $t('actions.close') }}
          </c-btn>
        </v-col>
      </v-row>
      <div class="slider">
        <Resource rounded
          contain
          v-bind="$attrs"
          :resource="currentResource"
          :max-height="maxHeight"
          :max-width="1020"
          class="mb-4"
          @videoEnded="emitEnded()"/>
      </div>
      <c-btn css="previous-resource"
        outlined color="white"
        @click="previous"><v-icon>chevron_left</v-icon></c-btn>
      <c-btn css="next-resource"
        outlined color="white"
        @click="next"><v-icon>chevron_right</v-icon></c-btn>
      <div class="votos" v-if="isChallenge">
        <button type="button" :class="{'boton verde': !challenge.liked, 'boton rojo': challenge.liked}" class="redondo lf2 txtvoto izq" @click.stop.prevent="likePost()">
          <img class="imgvoto" src="/retodelmes/july_files/like.svg">
          <span class="numlikes">{{ challenge.likesCount }}</span>
        </button>
      </div>
    </div>

    <c-dialog persistent
              width="600"
              v-bind:value="dialog"
              @close="close">
      <span v-if="!authenticated">
        <h2 class="tit-cont-form" id="titleForm" v-html="setTitleForm"></h2>
        <div class="separa xs-size"></div>
        <span>by </span><img src="/retodelmes/july_files/logo-loverfans.svg" alt="Loverfans" style="width: 140px">
        <div class="separa s-size"></div>
        <p class="parr-cont-form fuente-destacada3" v-html="setSigntitle"></p>
        <SmallSignupForm @close="close"></SmallSignupForm>
      </span>
      <SubscriptionPayment v-else :resource="user"></SubscriptionPayment>
    </c-dialog>
  </v-overlay>
</template>
<script>
import { mapState } from 'vuex'
import Resource from '@/components/posts/Resource'
import dialog from '@/components/mixins/dialog'
import validatable from '@/components/mixins/validatable'
import SubscriptionPayment from '@/components/payments/forms/SubscriptionPayment'
import { UserActions } from '@/store'
import SmallSignupForm from "@/components/sessions/SmallSignupForm";

export default {
  name: 'Carousel',
  components: {Resource, SubscriptionPayment, SmallSignupForm },
  mixins: [dialog, validatable('form')],
  props: {
    value: Boolean,
    resources: Array,
    selected: Object,
    user: Object,
    challenge: { type: Object, default: null }
  },
  data () {
    return {
      current: 0
    }
  },

  computed: {
    ...mapState('session', ['authenticated']),
    ...mapState('application', ['screenHeight']),
    isChallenge () {
      return this.challenge && this.challenge.available
    },

    setTitleForm () {
      var spa_text = 'RETO DEL MES'
      var eng_text = 'MONTHLY CHALLENGE'

      return this.$i18n.locale === 'es' ? spa_text : eng_text
    },

    setSigntitle () {
      var spa_text = 'Regístrate para <strong>votar</strong> y elige la <strong>paja más loca</strong>'
      var eng_text = 'Regístrate para <strong>votar</strong> y elige la <strong>paja más loca</strong>'

      return this.$i18n.locale === 'es' ? spa_text : eng_text
    },

    currentResource () {
      return this.resources[this.current]
    },
    total () {
      return this.resources ? this.resources.length : 0
    },
    maxHeight () {
      return this.screenHeight - 130
    }
  },

  watch: {
    selected (value) {
      this.current = this.resources.indexOf(value)
    }
  },

  methods: {
    close () {
      this.$emit('input', false)
    },
    previous () {
      this.current = Math.abs((this.current - 1) % this.total)
    },
    next () {
      this.current = (this.current + 1) % this.total
    },
    emitEnded () {
      // this.$emit('videoEnded')
      this.dialog = !this.dialog
    },
    likePost () {
      this.$emit('likePost')
    }
  },
  async mounted () {
    if (this.selected) {
      this.current = this.resources.indexOf(this.selected)
    }
    if (this.user) {
      this.user = await this.$store.dispatch(UserActions.Fetch, { username: this.user })
    }
  }
}

</script>
<style lang="scss">
.carousel {
  .v-overlay__content {
    margin-top: 50px;
    height: 100% !important;
    width: 100% !important;
  }

  .carousel-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    .actions {
      height: 65px;
    }
    .slider {
      height: calc(100% - 65px);
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 15px;
      .image {
        max-height: calc(100% - 65px);
        padding: 0 15px;
      }
    }
    .previous-resource {
      position: absolute;
      left: 15px;
      top: 50%;
      bottom: 50%;
    }
    .next-resource {
      position: absolute;
      right: 15px;
      top: 50%;
      bottom: 50%;
    }
  }

  .votos {
    margin-right: 50% !important;
  }
}
</style>
